module.exports = __webpack_public_path__ + "img/personAccess.0c740b7f.svg";